import React from 'react';
import PropTypes from 'prop-types';
import Currency from '../Currency';
import CirclesLoadingAnimation from '../Loaders/CirclesLoadingAnimation';

const DisplayPrice = (props) => {
  const {
    price,
    isFetching,
    hidePrice,
    currencyStyling,
  } = props;

  if (hidePrice) {
    return (
      <Currency value={null} placeholder="-" styling={currencyStyling} />
    );
  }

  if (isFetching) {
    return (
      <CirclesLoadingAnimation />
    );
  }

  return (
    <Currency
      value={price}
      currency="AMD"
      placeholder="-"
      withSymbol
      styling={currencyStyling}
    />
  );
};

DisplayPrice.propTypes = {
  price: PropTypes.number,
  isFetching: PropTypes.bool,
  hidePrice: PropTypes.bool,
  currencyStyling: PropTypes.instanceOf(Object),
};

DisplayPrice.defaultProps = {
  isFetching: false,
  hidePrice: false,
  currencyStyling: null,
  price: 0,
};

export default DisplayPrice;
